import { request } from '@vfde-fe/sails_core';
import { API_DEV_KEY, API_DEV_URL, API_KEY, API_URL } from 'Constant';
import { SalesChannel } from '../enum';
import TariffRequest from '../interface/TariffRequest';
import TariffResponse from '../interface/TariffResponse';
import { getDiscountIds, getProductIds, getSubscriptionIds } from './additionalPageOptionsHelper';
import { isProdEnv } from '@vfde-fe/utils';

const getOptions = (prodEnv: boolean): Object => {
    const headers = {
        'x-api-key': prodEnv ? API_KEY : API_DEV_KEY,
        'Content-Type': 'application/json',
    };
    const options = {
        method: 'GET',
        headers,
    };

    return options;
};

const constructUrl = (prodEnv: boolean, salesChannel: SalesChannel): URL => {
    const urlString = prodEnv ? API_URL : API_DEV_URL;
    const url = new URL(urlString);

    const salesChannelArray =
        salesChannel === SalesChannel.FF
            ? [salesChannel]
            : [SalesChannel.CONSUMER, SalesChannel.YOUNG];

    const params: TariffRequest = {
        businessTransaction: 'newContract',
        discountId: getDiscountIds(salesChannel),
        hardwareId: getProductIds(),
        salesChannel: salesChannelArray,
        virtualItemId: getSubscriptionIds(),
    };

    for (const key in params) {
        const param = params[key];

        if (Array.isArray(param)) {
            param.forEach(item => {
                url.searchParams.append(key, item);
            });
        } else {
            url.searchParams.append(key, param);
        }
    }

    return url;
};

/**
 * Initiates an API call to fetch the tariffs
 *
 * @returns Promise<TariffResponse>
*/
export const getTariff = (salesChannel: SalesChannel): Promise<TariffResponse> => {
    const prodEnv = isProdEnv();

    const options = getOptions(prodEnv);
    const url = constructUrl(prodEnv, salesChannel);

    return request(url.toString(), options);
};
